/** Backend REST API base URL (`REACT_APP_BASE_URL`). Not the public marketing site. */
export const baseURL = process.env.REACT_APP_BASE_URL;

export let urlPrefix = "/"; //when on landing page (not logged in) the url for product page is https://ceras-analytics.com/products

export const FIREBASE_CONFIG = process.env.REACT_APP_FIREBASE_CONFIG;

export const LOGIN_URL = "/app/login";
